import { LoadingButton } from "@mui/lab";
import { useTranslation } from "react-i18next";
import { USER_ROLES } from "../../../../../helpers/constants";
import { useHasRole } from "../../../../../hooks/auth/useCheckPermission";
import { useDialogBetter } from "../../../../../hooks/useDialogBetter";
import ConfirmationDialog from "../../../../../components/dialog/ConfirmationDialog/confirmationDialog";
import { useSetFinalSettlementAgreement } from "../../../../../services/agreementsService";
import toast from "react-hot-toast";
import { SnackbarSuccess } from "../../../../../components/base/SnackbarAlert/SnackbarSuccess";
import { SnackbarError } from "../../../../../components/base/SnackbarAlert/SnackbarError";
import { AgreementKindEnum } from "../../../../../schemas/agreements";

export const FinalSettlementButton = (props) => {
    const { agreementId, agreementFinalSettlement, isInvestmentEffectiveFootageFilled, agreementKind, products, readOnly, sx } = props;
    const { t } = useTranslation();

    const userHasPermisionToFinalSettlementSettlement = useHasRole([USER_ROLES.ADMIN, USER_ROLES.SALES_LEGAL, USER_ROLES.SALES_MANAGER]);
    const isFinalSettlementSettlementButtonActive = () => {
        return ( 
            !readOnly && 
            agreementKind !== AgreementKindEnum.RESERVATION &&
            !agreementFinalSettlement && 
            isInvestmentEffectiveFootageFilled &&
            userHasPermisionToFinalSettlementSettlement &&
            products && products.length > 0 &&
            products.every(product => product?.product?.footage_postconstruction)
        )
    }

      const {
        openDialog: openPostConstructionSettlementAgreementConfirmationDialog,
        closeDialog: closePostConstructionSettlementAgreementConfirmationDialog,
      } = useDialogBetter();

        const { mutate: finalSettlementAgreement, isPending: isFinalSettlementAgreementLoading } = useSetFinalSettlementAgreement({
            onSuccess: () => {
                toast.custom(
                    () => (
                        <SnackbarSuccess message={t("agreements.AgreementProductsTab.postConstructionSettlementSuccess")} />
                    ),
                    {
                        position: "bottom-right",
                    },
                );
            },
            onError: (error) => {
                console.error("Error FinalSettlement agreement:", error);
                toast.custom(
                    () => <SnackbarError message={t("agreements.AgreementProductsTab.postConstructionSettlementError")} />,
                    {
                        position: "bottom-right",
                    },
                );
            },
        });

    return (
        <LoadingButton
            sx={sx} 
            variant="outlined"
            color="primary"
            loading={isFinalSettlementAgreementLoading}
            disabled={!isFinalSettlementSettlementButtonActive() || isFinalSettlementAgreementLoading}
            onClick={()=> openPostConstructionSettlementAgreementConfirmationDialog({
                        Component: ConfirmationDialog,
                        componentProps: {
                        title: t("agreements.AgreementProductsTab.FinalSettlementSettlementAgreementConfirmation"),
                        onYes: () => {
                            finalSettlementAgreement({ agreementId });
                            closePostConstructionSettlementAgreementConfirmationDialog()
                        } ,
                        onNo: closePostConstructionSettlementAgreementConfirmationDialog,
                        },
                    })  
            }>
            {t("agreements.AgreementProductsTab.postConstructionSettlement")}
        </LoadingButton>
    )
};
